<div class="curtain">

<section class="component-modalDialog redesigned size-6">
    <header>
        Vložit odkaz jako přílohu/dokument
        <a class="closeModalDialog fa fa-close" (click)="close()"></a>
    </header>
    <div class="contentContainer scrollable nativeScrollbar inside" >
        <ca-loading [loadState]="loading">
        <div *ngIf="!loading">

            <div class="col-4">
                <label for="link-name" class="entry-label">název</label>
                <input
                    [(ngModel)]="name"
                    type="text"
                    id="link-name"
                    placeholder="název souboru"
                    maxlength="255"
                    required
                    autofocus />
            </div>

            <div class="col-4">
                <label for="link-url" class="entry-label description">URL</label>
                <input
                    [(ngModel)]="url"
                    type="text"
                    id="link-url"
                    placeholder="URL odkazu"
                    required />
            </div>

        </div>
        </ca-loading>
    </div>
    <footer *ngIf="!loading">
        <a class="button-primary" (click)="save()">Uložit</a>
        <a class="button-secondary" (click)="close()">Storno</a>
    </footer>
</section>

</div><!-- curtain -->